import React, { useState } from 'react';
import styles from '../app.module.css';

const ExternalDocsSection = ({ formData, handleInputChange }) => {
  const [tempDocs, setTempDocs] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSaveDocs = () => {
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    const newErrors = {};

    if (!tempDocs?.url) {
      newErrors.url = 'URL is required.';
    } else if (!urlPattern.test(tempDocs.url)) {
      newErrors.url = 'Invalid URL format. Ensure it starts with http:// or https:// and has a valid domain.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    handleInputChange('externalDocs', 'description', tempDocs.description);
    handleInputChange('externalDocs', 'url', tempDocs.url);

    setTempDocs(null);
    setErrors({});
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempDocs(null);
    setErrors({});
    setIsEditing(false);
  };

  const handleEditDocs = () => {
    setTempDocs({ ...formData });
    setIsEditing(true);
  };

  return (
    <div>
      <h3 className={styles.centeredHeading}>External Documentation</h3>

      {formData?.url && !isEditing ? (
        <div className={styles.mainContainer}>
          <p>
            <strong>Description:</strong> {formData.description || 'N/A'}
          </p>
          <p>
            <strong>URL:</strong> {formData.url}
          </p>
          <div className={styles.actionButtonsContainer}>
            <button className={styles.editButton} onClick={handleEditDocs}> Edit </button>
            <button
              className={styles.deleteButton}
              onClick={() => {
                handleInputChange('externalDocs', 'description', '');
                handleInputChange('externalDocs', 'url', '');
              }}
            >
              Delete
            </button>
          </div>
        </div>
      ) : isEditing || tempDocs ? (
        <div className={styles.editMainContainer}>
          <div>
            <label>Description:</label>
            <input
              type="text"
              value={tempDocs?.description || ''}
              onChange={(e) => setTempDocs({ ...tempDocs, description: e.target.value })}
              placeholder="Enter description"
              className={styles.textBox}
            />
          </div>
          <div>
            <label>
              URL <span className={styles.requiredField}>*</span>
            </label>
            <input
              type="text"
              value={tempDocs?.url || ''}
              onChange={(e) => setTempDocs({ ...tempDocs, url: e.target.value })}
              placeholder="Enter URL"
              className={styles.textBox}
            />
            {errors.url && <p className={styles.inlineAlerts}>{errors.url}</p>}
          </div>
          <div className={styles.sNcButtonContainer}>
            <button className={styles.saveButton} onClick={handleSaveDocs}> Save </button>
            <button className={styles.cancelButton} onClick={handleCancel}> Cancel </button>
          </div>
        </div>
      ) : (
        <button className={styles.addNewButton} onClick={() => setTempDocs({ description: '', url: '' })}> + Add External Docs </button>
      )}
    </div>
  );
};

export default ExternalDocsSection;
